import { useTheme } from '@mui/material';

import SelectionTabs from '@webclient/components/search-forms/gamification-search/actions/filters/components/selection-tabs';
import SearchModeTab from '@webclient/components/search-mode-tab';

import AnotationDotsRoundedIcon from '~icons/knowz-iconify/annotation-dots';

import { useTranslate } from '@tolgee/react';

export default function Thoughfulness() {
  const { t } = useTranslate();
  const theme = useTheme();

  return (
    <SelectionTabs
      title={t(
        'layout.searchWidget.filters.Thoughtfulness.title',
        'Thoughtfulness',
      )}
      subtitle={t(
        'layout.searchWidget.filters.Thoughtfulness.subtitle',
        'How long should Knowz think before answering? longer insights use more credits, Genius mode will perform multi-step deep research.',
      )}
      Icon={<AnotationDotsRoundedIcon color={theme.palette.utility.gray700} />}
    >
      <SearchModeTab />
    </SelectionTabs>
  );
}
